import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import {
    ChevronDown,
    Users,
    Plus,
    Briefcase,
    FileText,
    FileCheck,
    FileQuestion,
    UserCircle2,
    Cog
} from "lucide-react";
import {
    Sidebar,
    SidebarContent,
    SidebarHeader,
    SidebarRail,
} from "@/components/ui/sidebar";

export function AppSidebar({ ...props }) {
    const location = useLocation();
    const [isCandidatesOpen, setIsCandidatesOpen] = React.useState(false);
    const [isClientsOpen, setIsClientsOpen] = React.useState(false);
    const [isJobsOpen, setIsJobsOpen] = React.useState(false);
    const [isSetupOpen, setIsSetupOpen] = React.useState(false);

    const isActive = (path) => location.pathname === path;

    return (
        <Sidebar collapsible="icon" {...props}>
            <SidebarContent>
                {/* Jobs Section */}
                <div className="mb-4">
                    <button
                        onClick={() => setIsJobsOpen(!isJobsOpen)}
                        className="flex items-center justify-between w-full text-[#5D1F42] font-semibold text-lg p-2 hover:bg-gray-100 rounded-md"
                    >
                        <span className="flex items-center">
                            <Briefcase className="w-5 h-5 mr-2" />
                            Jobs
                        </span>
                        <ChevronDown
                            className={`w-5 h-5 transform transition-transform duration-200 ${
                                isJobsOpen ? "rotate-180" : ""
                            }`}
                        />
                    </button>
                    {isJobsOpen && (
                        <ul className="mt-2 space-y-2 pl-6">
                            <li>
                                <Link
                                    to="/admin/jobs?scope=previous"
                                    className={`flex items-center p-2 rounded-md ${
                                        location.pathname === "/admin/jobs" &&
                                        location.search === "?scope=previous"
                                            ? "bg-[#f2e9ec] text-[#5D1F42] font-medium"
                                            : "text-gray-700 hover:text-[#5D1F42] hover:bg-gray-100"
                                    }`}
                                >
                                    History
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/jobs?scope=future"
                                    className={`flex items-center p-2 rounded-md ${
                                        location.pathname === "/admin/jobs" &&
                                        location.search === "?scope=future"
                                            ? "bg-[#f2e9ec] text-[#5D1F42] font-medium"
                                            : "text-gray-700 hover:text-[#5D1F42] hover:bg-gray-100"
                                    }`}
                                >
                                    Future
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/jobs?scope=all"
                                    className={`flex items-center p-2 rounded-md ${
                                        location.pathname === "/admin/jobs" &&
                                        location.search === "?scope=all"
                                            ? "bg-[#f2e9ec] text-[#5D1F42] font-medium"
                                            : "text-gray-700 hover:text-[#5D1F42] hover:bg-gray-100"
                                    }`}
                                >
                                    All
                                </Link>
                            </li>
                        </ul>
                    )}
                </div>

                {/* Candidates Section */}
                <div className="mb-4">
                    <button
                        onClick={() => setIsCandidatesOpen(!isCandidatesOpen)}
                        className="flex items-center justify-between w-full text-[#5D1F42] font-semibold text-lg p-2 hover:bg-gray-100 rounded-md"
                    >
                        <span className="flex items-center">
                            <Users className="w-5 h-5 mr-2" />
                            Candidates
                        </span>
                        <ChevronDown
                            className={`w-5 h-5 transform transition-transform duration-200 ${
                                isCandidatesOpen ? "rotate-180" : ""
                            }`}
                        />
                    </button>
                    {isCandidatesOpen && (
                        <ul className="mt-2 space-y-2 pl-6">
                            <li>
                                <Link
                                    to="/admin"
                                    className={`flex items-center p-2 rounded-md ${
                                        isActive("/admin")
                                            ? "bg-[#f2e9ec] text-[#5D1F42] font-medium"
                                            : "text-gray-700 hover:text-[#5D1F42] hover:bg-gray-100"
                                    }`}
                                >
                                    <Users className="w-4 h-4 mr-2" />
                                    Index
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/candidate_availability"
                                    className={`flex items-center p-2 rounded-md ${
                                        isActive("/admin")
                                            ? "bg-[#f2e9ec] text-[#5D1F42] font-medium"
                                            : "text-gray-700 hover:text-[#5D1F42] hover:bg-gray-100"
                                    }`}
                                >
                                    <Users className="w-4 h-4 mr-2" />
                                    Availability
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/candidate/new"
                                    className={`flex items-center p-2 rounded-md ${
                                        isActive("/admin/candidate/new")
                                            ? "bg-[#f2e9ec] text-[#5D1F42] font-medium"
                                            : "text-gray-700 hover:text-[#5D1F42] hover:bg-gray-100"
                                    }`}
                                >
                                    <Plus className="w-4 h-4 mr-2" />
                                    New Candidate
                                </Link>
                            </li>
                        </ul>
                    )}
                </div>

                {/* Clients Section */}
                <div className="mb-4">
                    <button
                        onClick={() => setIsClientsOpen(!isClientsOpen)}
                        className="flex items-center justify-between w-full text-[#5D1F42] font-semibold text-lg p-2 hover:bg-gray-100 rounded-md"
                    >
                        <span className="flex items-center">
                            <UserCircle2 className="w-5 h-5 mr-2" />
                            Clients
                        </span>
                        <ChevronDown
                            className={`w-5 h-5 transform transition-transform duration-200 ${
                                isClientsOpen ? "rotate-180" : ""
                            }`}
                        />
                    </button>
                    {isClientsOpen && (
                        <ul className="mt-2 space-y-2 pl-6">
                            <li>
                                <Link
                                    to="/admin/venues"
                                    className={`flex items-center p-2 rounded-md ${
                                        isActive("/admin/clients")
                                            ? "bg-[#f2e9ec] text-[#5D1F42] font-medium"
                                            : "text-gray-700 hover:text-[#5D1F42] hover:bg-gray-100"
                                    }`}
                                >
                                    <Users className="w-4 h-4 mr-2" />
                                    Index
                                </Link>
                            </li>
                            {/*<li>*/}
                            {/*    <Link*/}
                            {/*        to="/admin/clients/new"*/}
                            {/*        className={`flex items-center p-2 rounded-md ${*/}
                            {/*            isActive("/admin/clients/new")*/}
                            {/*                ? "bg-[#f2e9ec] text-[#5D1F42] font-medium"*/}
                            {/*                : "text-gray-700 hover:text-[#5D1F42] hover:bg-gray-100"*/}
                            {/*        }`}*/}
                            {/*    >*/}
                            {/*        <Plus className="w-4 h-4 mr-2" />*/}
                            {/*        New*/}
                            {/*    </Link>*/}
                            {/*</li>*/}
                        </ul>
                    )}
                </div>

                {/* Time Sheets Section */}
                <div className="mb-4">
                    <Link
                        to="/admin/timesheets"
                        className={`flex items-center p-2 rounded-md text-[#5D1F42] font-semibold text-lg hover:bg-gray-100 ${
                            isActive("/admin/time-sheets") ? "bg-[#f2e9ec]" : ""
                        }`}
                    >
                        <FileCheck className="w-5 h-5 mr-2" />
                        Time Sheets
                    </Link>
                </div>

                {/* Setup Section */}
                <div className="mb-4">
                    <button
                        onClick={() => setIsSetupOpen(!isSetupOpen)}
                        className="flex items-center justify-between w-full text-[#5D1F42] font-semibold text-lg p-2 hover:bg-gray-100 rounded-md"
                    >
                        <span className="flex items-center">
                            <Cog className="w-5 h-5 mr-2" />
                            Setup
                        </span>
                        <ChevronDown
                            className={`w-5 h-5 transform transition-transform duration-200 ${
                                isSetupOpen ? "rotate-180" : ""
                            }`}
                        />
                    </button>
                    {isSetupOpen && (
                        <ul className="mt-2 space-y-2 pl-6">
                            <li>
                                <Link
                                    to="/admin/skills"
                                    className={`flex items-center p-2 rounded-md ${
                                        isActive("/admin/skills")
                                            ? "bg-[#f2e9ec] text-[#5D1F42] font-medium"
                                            : "text-gray-700 hover:text-[#5D1F42] hover:bg-gray-100"
                                    }`}
                                >
                                    <Briefcase className="w-4 h-4 mr-2" />
                                    Job Titles & Pricing
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/terms"
                                    className={`flex items-center p-2 rounded-md ${
                                        isActive("/admin/terms")
                                            ? "bg-[#f2e9ec] text-[#5D1F42] font-medium"
                                            : "text-gray-700 hover:text-[#5D1F42] hover:bg-gray-100"
                                    }`}
                                >
                                    <FileText className="w-4 h-4 mr-2" />
                                    Terms & Compliance
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/questions"
                                    className={`flex items-center p-2 rounded-md ${
                                        isActive("/admin/questionnaire")
                                            ? "bg-[#f2e9ec] text-[#5D1F42] font-medium"
                                            : "text-gray-700 hover:text-[#5D1F42] hover:bg-gray-100"
                                    }`}
                                >
                                    <FileQuestion className="w-4 h-4 mr-2" />
                                    Questionnaire
                                </Link>
                            </li>
                        </ul>
                    )}
                </div>

            </SidebarContent>
            <SidebarRail />
        </Sidebar>
    );
}
